import { useQuery } from '@hooks/reactQuery';

import { getConnectionLogsVendors } from '@api/networkElements';

import { extractQueryParams } from '@utils/common';
import { nameTitleToOptionFormatted } from '@utils/formatter';

import { IOrganizationId } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_VENDORS_OPTIONS } from '@constants/queryKeys';

interface IUseQueryNetworkElementsVendorsReturned {
	vendorOptions: TSelectOption[];
	isLoadingVendorOptions: boolean;
}

const useQueryNetworkElementsVendors = (params: Partial<IOrganizationId>): IUseQueryNetworkElementsVendorsReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_VENDORS_OPTIONS, params],
		queryFn: extractQueryParams(getConnectionLogsVendors),
		select: (data) => nameTitleToOptionFormatted(data),
		allowedRoles: [EUserRoles.smoLightUpdater, EUserRoles.smoLightViewer],
		...refetchOptions,
	});

	return {
		vendorOptions: data || [],
		isLoadingVendorOptions: (isLoading && !!data) || isFetching,
	};
};

export default useQueryNetworkElementsVendors;
